// // // // import React, { useEffect, useState, createContext } from 'react';
// // // // import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';

// // // // // --- Page & Layout Components ---
// // // // import DashboardPage from './component/pages/Dashboard/Dashboard';
// // // // import Sidebar from './component/pages/Dashboard/Sidebar';
// // // // import Navbar from './component/Navbar/Navbar';
// // // // import SettingPageMain from './component/pages/Dashboard/setting/pages/SettingPageMain';
// // // // import TaskDetailPage from './component/Task/TaskDetailPage';
// // // // import TasksListPage from './component/Task/TasksListPage';
// // // // import CreateTaskPage from './component/Task/CreateTaskPage';
// // // // import Project from './component/pages/Dashboard/Project/Project';
// // // // import Assets from './component/pages/Dashboard/AssetsModule/Assets';
// // // // import Team from './component/Organization/Team';
// // // // import TeamManagement from './component/Organization/TeamManagement';
// // // // import CommonMaster from '../src/component/Common_master/CommonMaster.js';
// // // // import CustomerList from './component/pages/Dashboard/Customer/customer-list.jsx';
// // // // import CustomerForm from './component/pages/Dashboard/Customer/form.jsx';
// // // // import AdminManager from './component/AdminManager/AdminManager.js';
// // // // import FloatingActionButton from './component/common/FloatingActionButton';
// // // // import ReportsPage from '../src/component/Report/Report.js';
// // // // import ReportSettingsPage from '../src/component/Report/Reportsetting.js';
// // // // import './App.css';

// // // // // --- Create and export the RefreshContext ---
// // // // export const RefreshContext = createContext();

// // // // // --- REDIRECT URL ---
// // // // const ZTOOL_LOGIN_REDIRECT_URL = `${process.env.REACT_APP_ZTOOL_URL}/login`;

// // // // // --- JWT PARSING HELPER ---
// // // // const parseJwt = (token) => {
// // // //     try {
// // // //         const base64Url = token.split('.')[1];
// // // //         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
// // // //         const jsonPayload = decodeURIComponent(
// // // //             atob(base64).split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
// // // //         );
// // // //         return JSON.parse(jsonPayload);
// // // //     } catch (error) {
// // // //         console.error('Auth Error: Failed to parse JWT.', error);
// // // //         return null;
// // // //     }
// // // // };

// // // // // --- HELPER COMPONENTS ---
// // // // const RedirectToLogin = ({ message }) => {
// // // //     useEffect(() => {
// // // //         window.location.replace(ZTOOL_LOGIN_REDIRECT_URL);
// // // //     }, []);
// // // //     return (
// // // //         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
// // // //             <h1>{message || 'Redirecting to Login...'}</h1>
// // // //         </div>
// // // //     );
// // // // };

// // // // const ZTaskLoginPlaceholder = () => <RedirectToLogin />;

// // // // // --- NEW: Main Layout Component ---
// // // // // This component holds the persistent UI structure (Sidebar, Navbar)
// // // // // so it doesn't get remounted by the AuthHandler.
// // // // const MainLayout = () => {
// // // //     const [sidebarRefreshKey, setSidebarRefreshKey] = useState(0);
// // // //     const [refreshKey, setRefreshKey] = useState(0);

// // // //     const handleProfileUpdate = () => {
// // // //         setSidebarRefreshKey((prevKey) => prevKey + 1);
// // // //     };

// // // //     const triggerRefresh = () => {
// // // //         setRefreshKey((prevKey) => prevKey + 1);
// // // //     };

// // // //     return (
// // // //         <RefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
// // // //             <div className="app-layout">
// // // //                 <Sidebar refreshKey={sidebarRefreshKey} />
// // // //                 <div className="main-content-area">
// // // //                     <Navbar /> {/* Navbar is now in a stable parent */}
// // // //                     <div className="page-content-wrapper">
// // // //                         <Routes>
// // // //                             <Route path="/" element={<DashboardPage />} />
// // // //                             <Route path="/dashboard" element={<DashboardPage />} />
// // // //                             <Route path="/tasks" element={<TasksListPage />} />
// // // //                             <Route path="/tasks/create" element={<CreateTaskPage />} />
// // // //                             <Route path="/tasks/:taskId" element={<TaskDetailPage />} />
// // // //                             <Route path="/assets" element={<Assets />} />
// // // //                             <Route path="/project" element={<Project />} />
// // // //                             <Route path="/organization/team" element={<Team />} />
// // // //                             <Route path="/organization/team-management" element={<TeamManagement />} />
// // // //                             <Route path="/organization/user-management" element={<AdminManager onProfileUpdate={handleProfileUpdate} />} />
// // // //                             <Route path="/organization/common-master" element={<CommonMaster />} />
// // // //                             <Route path="/customers" element={<CustomerList />} />
// // // //                             <Route path="/customers/new" element={<CustomerForm />} />
// // // //                             <Route path="/customers/edit/:rowId" element={<CustomerForm />} />
// // // //                             <Route path="/settings/*" element={<SettingPageMain onProfileUpdate={handleProfileUpdate} />} />
// // // //                             <Route path="/reports" element={<ReportsPage />} />
// // // //                             <Route path="/reports/settings" element={<ReportSettingsPage />} />
// // // //                             <Route path="/login" element={<ZTaskLoginPlaceholder />} />
// // // //                         </Routes>
// // // //                     </div>
// // // //                 </div>
// // // //                 <FloatingActionButton />
// // // //             </div>
// // // //         </RefreshContext.Provider>
// // // //     );
// // // // };

// // // // // --- AUTH HANDLER (Updated to render MainLayout) ---
// // // // const AuthHandler = ({ children }) => {
// // // //     const location = useLocation();
// // // //     const navigate = useNavigate();
// // // //     const [authStatus, setAuthStatus] = useState('PENDING');

// // // //     useEffect(() => {
// // // //         const searchParams = new URLSearchParams(location.search);
// // // //         const tokenFromUrl = searchParams.get('token');
// // // //         const userDetailsEncodedFromUrl = searchParams.get('userDetails');

// // // //         if (tokenFromUrl && userDetailsEncodedFromUrl) {
// // // //             try {
// // // //                 const userDetails = JSON.parse(decodeURIComponent(userDetailsEncodedFromUrl));
// // // //                 localStorage.setItem('zTaskAuthToken', tokenFromUrl);
// // // //                 localStorage.setItem('zTaskUserDetails', JSON.stringify(userDetails));
// // // //                 navigate(location.pathname, { replace: true, search: '' });
// // // //                 setAuthStatus('AUTHENTICATED');
// // // //             } catch (e) {
// // // //                 console.error('Auth Error: Failed to parse user details from URL.', e);
// // // //                 localStorage.clear();
// // // //                 setAuthStatus('FAILED');
// // // //             }
// // // //             return;
// // // //         }

// // // //         const tokenFromLocalStorage = localStorage.getItem('zTaskAuthToken');
// // // //         if (tokenFromLocalStorage) {
// // // //             const decodedToken = parseJwt(tokenFromLocalStorage);
// // // //             if (decodedToken && decodedToken.exp * 1000 < Date.now()) {
// // // //                 localStorage.clear();
// // // //                 setAuthStatus('EXPIRED');
// // // //             } else {
// // // //                 setAuthStatus('AUTHENTICATED');
// // // //             }
// // // //         } else {
// // // //             setAuthStatus('FAILED');
// // // //         }
// // // //     }, [location, navigate]);

// // // //     if (authStatus === 'PENDING')
// // // //         return (
// // // //             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
// // // //                 <h1>Verifying Session...</h1>
// // // //             </div>
// // // //         );
// // // //     if (authStatus === 'EXPIRED') return <RedirectToLogin message="Your session has expired. Redirecting..." />;
// // // //     if (authStatus === 'FAILED') return <RedirectToLogin />;

// // // //     // When authenticated, render the children passed to it.
// // // //     return children;
// // // // };

// // // // // --- Main App Component (Now cleaner) ---
// // // // const App = () => {
// // // //     return (
// // // //         <BrowserRouter>
// // // //             <AuthHandler>
// // // //                 {/* The entire stable layout is now the child of AuthHandler */}
// // // //                 <MainLayout />
// // // //             </AuthHandler>
// // // //         </BrowserRouter>
// // // //     );
// // // // };

// // // // export default App;

// // // import React, { useEffect, useState, createContext } from 'react';
// // // import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';

// // // // --- Page & Layout Components ---
// // // import DashboardPage from './component/pages/Dashboard/Dashboard';
// // // import Sidebar from './component/pages/Dashboard/Sidebar';
// // // import Navbar from './component/Navbar/Navbar';
// // // import SettingPageMain from './component/pages/Dashboard/setting/pages/SettingPageMain';
// // // import TaskDetailPage from './component/Task/TaskDetailPage';
// // // import TasksListPage from './component/Task/TasksListPage';
// // // import CreateTaskPage from './component/Task/CreateTaskPage';
// // // import Project from './component/pages/Dashboard/Project/Project';
// // // import Assets from './component/pages/Dashboard/AssetsModule/Assets';
// // // import Team from './component/Organization/Team';
// // // import TeamManagement from './component/Organization/TeamManagement';
// // // import CommonMaster from '../src/component/Common_master/CommonMaster.js';
// // // import CustomerList from './component/pages/Dashboard/Customer/customer-list.jsx';
// // // import CustomerForm from './component/pages/Dashboard/Customer/form.jsx';
// // // import AdminManager from './component/AdminManager/AdminManager.js';
// // // import FloatingActionButton from './component/common/FloatingActionButton';
// // // import ReportsPage from '../src/component/Report/Report.js';
// // // import ReportSettingsPage from '../src/component/Report/Reportsetting.js';
// // // import './App.css';

// // // // --- NEWLY ADDED: Imports for Work Order, Invoice, and Work Type ---
// // // import WorkOrder, { WorkOrderFormPage } from "./component/pages/Dashboard/WorkOrder/WorkOrder";
// // // import WorkOrderView from "./component/pages/Dashboard/WorkOrder/View";
// // // import Invoice, { InvoiceFormPage } from "./component/pages/Dashboard/Invoice/Invoice";
// // // // Assuming WorkTypePage is a new component you will create inside the CommonMaster folder
// // // // If it's part of CommonMaster itself, you can adjust the route's element prop.
// // // const WorkTypePage = () => <div style={{ padding: '20px' }}>Work Type Management Page</div>;

// // // // --- Create and export the RefreshContext ---
// // // export const RefreshContext = createContext();

// // // // --- REDIRECT URL ---
// // // const ZTOOL_LOGIN_REDIRECT_URL = `${process.env.REACT_APP_ZTOOL_URL}/login`;

// // // // --- JWT PARSING HELPER ---
// // // const parseJwt = (token) => {
// // //     try {
// // //         const base64Url = token.split('.')[1];
// // //         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
// // //         const jsonPayload = decodeURIComponent(
// // //             atob(base64).split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
// // //         );
// // //         return JSON.parse(jsonPayload);
// // //     } catch (error) {
// // //         console.error('Auth Error: Failed to parse JWT.', error);
// // //         return null;
// // //     }
// // // };

// // // // --- HELPER COMPONENTS ---
// // // const RedirectToLogin = ({ message }) => {
// // //     useEffect(() => {
// // //         window.location.replace(ZTOOL_LOGIN_REDIRECT_URL);
// // //     }, []);
// // //     return (
// // //         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
// // //             <h1>{message || 'Redirecting to Login...'}</h1>
// // //         </div>
// // //     );
// // // };

// // // const ZTaskLoginPlaceholder = () => <RedirectToLogin />;

// // // // --- Main Layout Component ---
// // // const MainLayout = () => {
// // //     const [sidebarRefreshKey, setSidebarRefreshKey] = useState(0);
// // //     const [refreshKey, setRefreshKey] = useState(0);

// // //     const handleProfileUpdate = () => {
// // //         setSidebarRefreshKey((prevKey) => prevKey + 1);
// // //     };

// // //     const triggerRefresh = () => {
// // //         setRefreshKey((prevKey) => prevKey + 1);
// // //     };

// // //     return (
// // //         <RefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
// // //             <div className="app-layout">
// // //                 <Sidebar refreshKey={sidebarRefreshKey} />
// // //                 <div className="main-content-area">
// // //                     <Navbar />
// // //                     <div className="page-content-wrapper">
// // //                         <Routes>
// // //                             {/* --- Core Routes --- */}
// // //                             <Route path="/" element={<DashboardPage />} />
// // //                             <Route path="/dashboard" element={<DashboardPage />} />
// // //                             <Route path="/project" element={<Project />} />
// // //                             <Route path="/assets" element={<Assets />} />

// // //                             {/* --- Task Routes --- */}
// // //                             <Route path="/tasks" element={<TasksListPage />} />
// // //                             <Route path="/tasks/create" element={<CreateTaskPage />} />
// // //                             <Route path="/tasks/:taskId" element={<TaskDetailPage />} />

// // //                             {/* --- Customer Routes --- */}
// // //                             <Route path="/customers" element={<CustomerList />} />
// // //                             <Route path="/customers/new" element={<CustomerForm />} />
// // //                             <Route path="/customers/edit/:rowId" element={<CustomerForm />} />

// // //                             {/* --- NEW: Work Order Routes --- */}
// // //                             <Route path="/work-orders" element={<WorkOrder />} />
// // //                             <Route path="/work-orders/new" element={<WorkOrderFormPage />} />
// // //                             <Route path="/work-orders/edit/:id" element={<WorkOrderFormPage />} />
// // //                             <Route path="/work-orders/:id" element={<WorkOrderView />} />

// // //                             {/* --- NEW: Invoice Routes --- */}
// // //                             <Route path="/invoices" element={<Invoice />} />
// // //                             <Route path="/invoices/new" element={<InvoiceFormPage />} />
// // //                             <Route path="/invoices/edit/:id" element={<InvoiceFormPage />} />
// // //                             <Route path="/invoices/:id" element={<InvoiceFormPage />} />

// // //                             {/* --- Organization Routes --- */}
// // //                             <Route path="/organization/team" element={<Team />} />
// // //                             <Route path="/organization/team-management" element={<TeamManagement />} />
// // //                             <Route path="/organization/user-management" element={<AdminManager onProfileUpdate={handleProfileUpdate} />} />
// // //                             <Route path="/organization/common-master" element={<CommonMaster />} />
// // //                             {/* --- NEW: Work Type Route --- */}
// // //                             <Route path="/organization/work-type" element={<WorkTypePage />} />

// // //                             {/* --- Reports Routes --- */}
// // //                             <Route path="/reports" element={<ReportsPage />} />
// // //                             <Route path="/reports/settings" element={<ReportSettingsPage />} />

// // //                             {/* --- Settings & Auth Routes --- */}
// // //                             <Route path="/settings/*" element={<SettingPageMain onProfileUpdate={handleProfileUpdate} />} />
// // //                             <Route path="/login" element={<ZTaskLoginPlaceholder />} />
// // //                         </Routes>
// // //                     </div>
// // //                 </div>
// // //                 <FloatingActionButton />
// // //             </div>
// // //         </RefreshContext.Provider>
// // //     );
// // // };

// // // // --- AUTH HANDLER ---
// // // const AuthHandler = ({ children }) => {
// // //     const location = useLocation();
// // //     const navigate = useNavigate();
// // //     const [authStatus, setAuthStatus] = useState('PENDING');

// // //     useEffect(() => {
// // //         const searchParams = new URLSearchParams(location.search);
// // //         const tokenFromUrl = searchParams.get('token');
// // //         const userDetailsEncodedFromUrl = searchParams.get('userDetails');

// // //         if (tokenFromUrl && userDetailsEncodedFromUrl) {
// // //             try {
// // //                 const userDetails = JSON.parse(decodeURIComponent(userDetailsEncodedFromUrl));
// // //                 localStorage.setItem('zTaskAuthToken', tokenFromUrl);
// // //                 localStorage.setItem('zTaskUserDetails', JSON.stringify(userDetails));
// // //                 navigate(location.pathname, { replace: true, search: '' });
// // //                 setAuthStatus('AUTHENTICATED');
// // //             } catch (e) {
// // //                 console.error('Auth Error: Failed to parse user details from URL.', e);
// // //                 localStorage.clear();
// // //                 setAuthStatus('FAILED');
// // //             }
// // //             return;
// // //         }

// // //         const tokenFromLocalStorage = localStorage.getItem('zTaskAuthToken');
// // //         if (tokenFromLocalStorage) {
// // //             const decodedToken = parseJwt(tokenFromLocalStorage);
// // //             if (decodedToken && decodedToken.exp * 1000 < Date.now()) {
// // //                 localStorage.clear();
// // //                 setAuthStatus('EXPIRED');
// // //             } else {
// // //                 setAuthStatus('AUTHENTICATED');
// // //             }
// // //         } else {
// // //             setAuthStatus('FAILED');
// // //         }
// // //     }, [location, navigate]);

// // //     if (authStatus === 'PENDING')
// // //         return (
// // //             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
// // //                 <h1>Verifying Session...</h1>
// // //             </div>
// // //         );
// // //     if (authStatus === 'EXPIRED') return <RedirectToLogin message="Your session has expired. Redirecting..." />;
// // //     if (authStatus === 'FAILED') return <RedirectToLogin />;

// // //     return children;
// // // };

// // // // --- Main App Component ---
// // // const App = () => {
// // //     return (
// // //         <BrowserRouter>
// // //             <AuthHandler>
// // //                 <MainLayout />
// // //             </AuthHandler>
// // //         </BrowserRouter>
// // //     );
// // // };

// // // export default App;

// // import React, { useEffect, useState, createContext } from 'react';
// // import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';

// // // --- Page & Layout Components ---
// // import DashboardPage from './component/pages/Dashboard/Dashboard';
// // import Sidebar from './component/pages/Dashboard/Sidebar';
// // import Navbar from './component/Navbar/Navbar';
// // import SettingPageMain from './component/pages/Dashboard/setting/pages/SettingPageMain';
// // import TaskDetailPage from './component/Task/TaskDetailPage';
// // import TasksListPage from './component/Task/TasksListPage';
// // import CreateTaskPage from './component/Task/CreateTaskPage';
// // import Project from './component/pages/Dashboard/Project/Project';
// // import Assets from './component/pages/Dashboard/AssetsModule/Assets';
// // import Team from './component/Organization/Team';
// // import TeamManagement from './component/Organization/TeamManagement';
// // import CommonMaster from '../src/component/Common_master/CommonMaster.js';
// // import CustomerList from './component/pages/Dashboard/Customer/customer-list.jsx';
// // import CustomerForm from './component/pages/Dashboard/Customer/form.jsx';
// // import AdminManager from './component/AdminManager/AdminManager.js';
// // import FloatingActionButton from './component/common/FloatingActionButton';
// // import ReportsPage from '../src/component/Report/Report.js';
// // import ReportSettingsPage from '../src/component/Report/Reportsetting.js';
// // import './App.css';

// // // --- NEWLY ADDED & CONSOLIDATED IMPORTS ---
// // import WorkOrder, { WorkOrderFormPage } from "./component/pages/Dashboard/WorkOrder/WorkOrder";
// // import WorkOrderView from "./component/pages/Dashboard/WorkOrder/View";
// // import Invoice, { InvoiceFormPage } from "./component/pages/Dashboard/Invoice/Invoice";
// // import WorkType, { WorkTypeFormPage } from "../src/component/pages/Dashboard/WorkType/WorkType.js"; // Added this import

// // // --- Create and export the RefreshContext ---
// // export const RefreshContext = createContext();

// // // --- REDIRECT URL (Corrected) ---
// // const ZTOOL_LOGIN_REDIRECT_URL = `${process.env.REACT_APP_ZTOOL_URL}/login`;

// // // --- JWT PARSING HELPER ---
// // const parseJwt = (token) => {
// //     try {
// //         const base64Url = token.split('.')[1];
// //         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
// //         const jsonPayload = decodeURIComponent(
// //             atob(base64).split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
// //         );
// //         return JSON.parse(jsonPayload);
// //     } catch (error){
// //         console.error('Auth Error: Failed to parse JWT.', error);
// //         return null;
// //     }
// // };

// // // --- HELPER COMPONENTS ---
// // const RedirectToLogin = ({ message }) => {
// //     useEffect(() => {
// //         window.location.replace(ZTOOL_LOGIN_REDIRECT_URL);
// //     }, []);
// //     return (
// //         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
// //             <h1>{message || 'Redirecting to Login...'}</h1>
// //         </div>
// //     );
// // };

// // const ZTaskLoginPlaceholder = () => <RedirectToLogin />;

// // // --- Main Layout Component ---
// // const MainLayout = () => {
// //     const [sidebarRefreshKey, setSidebarRefreshKey] = useState(0);
// //     const [refreshKey, setRefreshKey] = useState(0);

// //     const handleProfileUpdate = () => {
// //         setSidebarRefreshKey((prevKey) => prevKey + 1);
// //     };

// //     const triggerRefresh = () => {
// //         setRefreshKey((prevKey) => prevKey + 1);
// //     };

// //     return (
// //         <RefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
// //             <div className="app-layout">
// //                 <Sidebar refreshKey={sidebarRefreshKey} />
// //                 <div className="main-content-area">
// //                     <Navbar />
// //                     <div className="page-content-wrapper">
// //                         <Routes>
// //                             {/* --- Core Routes --- */}
// //                             <Route path="/" element={<DashboardPage />} />
// //                             <Route path="/dashboard" element={<DashboardPage />} />
// //                             <Route path="/project" element={<Project />} />
// //                             <Route path="/assets" element={<Assets />} />

// //                             {/* --- Task Routes --- */}
// //                             <Route path="/tasks" element={<TasksListPage />} />
// //                             <Route path="/tasks/create" element={<CreateTaskPage />} />
// //                             <Route path="/tasks/:taskId" element={<TaskDetailPage />} />

// //                             {/* --- Customer Routes --- */}
// //                             <Route path="/customers" element={<CustomerList />} />
// //                             <Route path="/customers/new" element={<CustomerForm />} />
// //                             <Route path="/customers/edit/:rowId" element={<CustomerForm />} />

// //                             {/* --- Work Order Routes (View and Edit are included) --- */}
// //                             <Route path="/work-orders" element={<WorkOrder />} />
// //                             <Route path="/work-orders/new" element={<WorkOrderFormPage />} />
// //                             <Route path="/work-orders/edit/:id" element={<WorkOrderFormPage />} />
// //                             <Route path="/work-orders/:id" element={<WorkOrderView />} />

// //                             {/* --- Invoice Routes --- */}
// //                             <Route path="/invoices" element={<Invoice />} />
// //                             <Route path="/invoices/new" element={<InvoiceFormPage />} />
// //                             <Route path="/invoices/edit/:id" element={<InvoiceFormPage />} />
// //                             <Route path="/invoices/:id" element={<InvoiceFormPage />} />

// //                             {/* --- Organization Routes --- */}
// //                             <Route path="/organization/team" element={<Team />} />
// //                             <Route path="/organization/team-management" element={<TeamManagement />} />
// //                             <Route path="/organization/user-management" element={<AdminManager onProfileUpdate={handleProfileUpdate} />} />
// //                             <Route path="/organization/common-master" element={<CommonMaster />} />

// //                             {/* --- NEW: Work Type Routes (Added from other file) --- */}
// //                             <Route path="/organization/work-types" element={<WorkType />} />
// //                             <Route path="/organization/work-types/new" element={<WorkTypeFormPage />} />
// //                             <Route path="/organization/work-types/edit/:rowId" element={<WorkTypeFormPage />} />

// //                             {/* --- Reports Routes --- */}
// //                             <Route path="/reports" element={<ReportsPage />} />
// //                             <Route path="/reports/settings" element={<ReportSettingsPage />} />

// //                             {/* --- Settings & Auth Routes --- */}
// //                             <Route path="/settings/*" element={<SettingPageMain onProfileUpdate={handleProfileUpdate} />} />
// //                             <Route path="/login" element={<ZTaskLoginPlaceholder />} />
// //                         </Routes>
// //                     </div>
// //                 </div>
// //                 <FloatingActionButton />
// //             </div>
// //         </RefreshContext.Provider>
// //     );
// // };

// // // --- AUTH HANDLER ---
// // const AuthHandler = ({ children }) => {
// //     const location = useLocation();
// //     const navigate = useNavigate();
// //     const [authStatus, setAuthStatus] = useState('PENDING');

// //     useEffect(() => {
// //         const searchParams = new URLSearchParams(location.search);
// //         const tokenFromUrl = searchParams.get('token');
// //         const userDetailsEncodedFromUrl = searchParams.get('userDetails');

// //         if (tokenFromUrl && userDetailsEncodedFromUrl) {
// //             try {
// //                 const userDetails = JSON.parse(decodeURIComponent(userDetailsEncodedFromUrl));
// //                 localStorage.setItem('zTaskAuthToken', tokenFromUrl);
// //                 localStorage.setItem('zTaskUserDetails', JSON.stringify(userDetails));
// //                 navigate(location.pathname, { replace: true, search: '' });
// //                 setAuthStatus('AUTHENTICATED');
// //             } catch (e) {
// //                 console.error('Auth Error: Failed to parse user details from URL.', e);
// //                 localStorage.clear();
// //                 setAuthStatus('FAILED');
// //             }
// //             return;
// //         }

// //         const tokenFromLocalStorage = localStorage.getItem('zTaskAuthToken');
// //         if (tokenFromLocalStorage) {
// //             const decodedToken = parseJwt(tokenFromLocalStorage);
// //             if (decodedToken && decodedToken.exp * 1000 < Date.now()) {
// //                 localStorage.clear();
// //                 setAuthStatus('EXPIRED');
// //             } else {
// //                 setAuthStatus('AUTHENTICATED');
// //             }
// //         } else {
// //             setAuthStatus('FAILED');
// //         }
// //     }, [location, navigate]);

// //     if (authStatus === 'PENDING')
// //         return (
// //             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
// //                 <h1>Verifying Session...</h1>
// //             </div>
// //         );
// //     if (authStatus === 'EXPIRED') return <RedirectToLogin message="Your session has expired. Redirecting..." />;
// //     if (authStatus === 'FAILED') return <RedirectToLogin />;

// //     return children;
// // };

// // // --- Main App Component ---
// // const App = () => {
// //     return (
// //         <BrowserRouter>
// //             <AuthHandler>
// //                 <MainLayout />
// //             </AuthHandler>
// //         </BrowserRouter>
// //     );
// // };

// // export default App;

// import React, { useEffect, useState, createContext } from 'react';
// import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';

// // --- Page & Layout Components ---
// import DashboardPage from './component/pages/Dashboard/Dashboard';
// import Sidebar from './component/pages/Dashboard/Sidebar';
// import Navbar from './component/Navbar/Navbar';
// import SettingPageMain from './component/pages/Dashboard/setting/pages/SettingPageMain';
// import TaskDetailPage from './component/Task/TaskDetailPage';
// import TasksListPage from './component/Task/TasksListPage';
// import CreateTaskPage from './component/Task/CreateTaskPage';
// import Project from './component/pages/Dashboard/Project/Project';
// import Assets from './component/pages/Dashboard/AssetsModule/Assets';
// import Team from './component/Organization/Team';
// import TeamManagement from './component/Organization/TeamManagement';
// import CommonMaster from '../src/component/Common_master/CommonMaster.js';
// import CustomerList from './component/pages/Dashboard/Customer/customer-list.jsx';
// import CustomerForm from './component/pages/Dashboard/Customer/form.jsx';
// import AdminManager from './component/AdminManager/AdminManager.js';
// import FloatingActionButton from './component/common/FloatingActionButton';
// import ReportsPage from '../src/component/Report/Report.js';
// import ReportSettingsPage from '../src/component/Report/Reportsetting.js';
// import './App.css';

// // --- NEWLY ADDED & CONSOLIDATED IMPORTS ---
// import WorkOrder, { WorkOrderFormPage } from "./component/pages/Dashboard/WorkOrder/WorkOrder";
// import WorkOrderView from "./component/pages/Dashboard/WorkOrder/View";
// import Invoice, { InvoiceFormPage } from "./component/pages/Dashboard/Invoice/Invoice";
// import WorkType, { WorkTypeFormPage } from "../src/component/pages/Dashboard/WorkType/WorkType.js";

// // --- Create and export the RefreshContext ---
// export const RefreshContext = createContext();

// // --- REDIRECT URL (Corrected) ---
// const ZTOOL_LOGIN_REDIRECT_URL = `${process.env.REACT_APP_ZTOOL_URL}/login`;

// // --- JWT PARSING HELPER ---
// const parseJwt = (token) => {
//     try {
//         const base64Url = token.split('.')[1];
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         const jsonPayload = decodeURIComponent(
//             atob(base64).split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
//         );
//         return JSON.parse(jsonPayload);
//     } catch (error){
//         console.error('Auth Error: Failed to parse JWT.', error);
//         return null;
//     }
// };

// // --- HELPER COMPONENTS ---
// const RedirectToLogin = ({ message }) => {
//     useEffect(() => {
//         window.location.replace(ZTOOL_LOGIN_REDIRECT_URL);
//     }, []);
//     return (
//         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//             <h1>{message || 'Redirecting to Login...'}</h1>
//         </div>
//     );
// };

// const ZTaskLoginPlaceholder = () => <RedirectToLogin />;

// // --- Main Layout Component ---
// const MainLayout = () => {
//     const [sidebarRefreshKey, setSidebarRefreshKey] = useState(0);
//     const [refreshKey, setRefreshKey] = useState(0);

//     const handleProfileUpdate = () => {
//         setSidebarRefreshKey((prevKey) => prevKey + 1);
//     };

//     const triggerRefresh = () => {
//         setRefreshKey((prevKey) => prevKey + 1);
//     };

//     return (
//         <RefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
//             <div className="app-layout">
//                 <Sidebar refreshKey={sidebarRefreshKey} />
//                 <div className="main-content-area">
//                     <Navbar />
//                     <div className="page-content-wrapper">
//                         <Routes>
//                             {/* --- Core Routes --- */}
//                             <Route path="/" element={<DashboardPage />} />
//                             <Route path="/dashboard" element={<DashboardPage />} />
//                             <Route path="/project" element={<Project />} />
//                             <Route path="/assets" element={<Assets />} />

//                             {/* --- Task Routes --- */}
//                             <Route path="/tasks" element={<TasksListPage />} />
//                             <Route path="/tasks/create" element={<CreateTaskPage />} />
//                             <Route path="/tasks/:taskId" element={<TaskDetailPage />} />

//                             {/* --- Customer Routes --- */}
//                             <Route path="/customers" element={<CustomerList />} />
//                             <Route path="/customers/new" element={<CustomerForm />} />
//                             <Route path="/customers/edit/:rowId" element={<CustomerForm />} />

//                             {/* --- Work Order Routes (View and Edit are included) --- */}
//                             <Route path="/work-orders" element={<WorkOrder />} />
//                             <Route path="/work-orders/new" element={<WorkOrderFormPage />} />

//                             {/* --- THIS IS THE CORRECTED ROUTE --- */}
//                             <Route path="/work-orders/:id/edit" element={<WorkOrderFormPage />} />

//                             <Route path="/work-orders/:id" element={<WorkOrderView />} />

//                             {/* --- Invoice Routes --- */}
//                             <Route path="/invoices" element={<Invoice />} />
//                             <Route path="/invoices/new" element={<InvoiceFormPage />} />
//                             <Route path="/invoices/edit/:id" element={<InvoiceFormPage />} />
//                             <Route path="/invoices/:id" element={<InvoiceFormPage />} />

//                             {/* --- Organization Routes --- */}
//                             <Route path="/organization/team" element={<Team />} />
//                             <Route path="/organization/team-management" element={<TeamManagement />} />
//                             <Route path="/organization/user-management" element={<AdminManager onProfileUpdate={handleProfileUpdate} />} />
//                             <Route path="/organization/common-master" element={<CommonMaster />} />

//                             {/* --- Work Type Routes --- */}
//                             <Route path="/organization/work-types" element={<WorkType />} />
//                             <Route path="/organization/work-types/new" element={<WorkTypeFormPage />} />
//                             <Route path="/organization/work-types/edit/:rowId" element={<WorkTypeFormPage />} />

//                             {/* --- Reports Routes --- */}
//                             <Route path="/reports" element={<ReportsPage />} />
//                             <Route path="/reports/settings" element={<ReportSettingsPage />} />

//                             {/* --- Settings & Auth Routes --- */}
//                             <Route path="/settings/*" element={<SettingPageMain onProfileUpdate={handleProfileUpdate} />} />
//                             <Route path="/login" element={<ZTaskLoginPlaceholder />} />
//                         </Routes>
//                     </div>
//                 </div>
//                 <FloatingActionButton />
//             </div>
//         </RefreshContext.Provider>
//     );
// };

// // --- AUTH HANDLER ---
// const AuthHandler = ({ children }) => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const [authStatus, setAuthStatus] = useState('PENDING');

//     useEffect(() => {
//         const searchParams = new URLSearchParams(location.search);
//         const tokenFromUrl = searchParams.get('token');
//         const userDetailsEncodedFromUrl = searchParams.get('userDetails');

//         if (tokenFromUrl && userDetailsEncodedFromUrl) {
//             try {
//                 const userDetails = JSON.parse(decodeURIComponent(userDetailsEncodedFromUrl));
//                 localStorage.setItem('zTaskAuthToken', tokenFromUrl);
//                 localStorage.setItem('zTaskUserDetails', JSON.stringify(userDetails));
//                 navigate(location.pathname, { replace: true, search: '' });
//                 setAuthStatus('AUTHENTICATED');
//             } catch (e) {
//                 console.error('Auth Error: Failed to parse user details from URL.', e);
//                 localStorage.clear();
//                 setAuthStatus('FAILED');
//             }
//             return;
//         }

//         const tokenFromLocalStorage = localStorage.getItem('zTaskAuthToken');
//         if (tokenFromLocalStorage) {
//             const decodedToken = parseJwt(tokenFromLocalStorage);
//             if (decodedToken && decodedToken.exp * 1000 < Date.now()) {
//                 localStorage.clear();
//                 setAuthStatus('EXPIRED');
//             } else {
//                 setAuthStatus('AUTHENTICATED');
//             }
//         } else {
//             setAuthStatus('FAILED');
//         }
//     }, [location, navigate]);

//     if (authStatus === 'PENDING')
//         return (
//             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//                 <h1>Verifying Session...</h1>
//             </div>
//         );
//     if (authStatus === 'EXPIRED') return <RedirectToLogin message="Your session has expired. Redirecting..." />;
//     if (authStatus === 'FAILED') return <RedirectToLogin />;

//     return children;
// };

// // --- Main App Component ---
// const App = () => {
//     return (
//         <BrowserRouter>
//             <AuthHandler>
//                 <MainLayout />
//             </AuthHandler>
//         </BrowserRouter>
//     );
// };

// export default App;

// import React, { useEffect, useState, createContext } from "react";
// import {
//   BrowserRouter,
//   Routes,
//   Route,
//   useLocation,
//   useNavigate,
// } from "react-router-dom";

// // --- Page & Layout Components ---
// import DashboardPage from "./component/pages/Dashboard/Dashboard";
// import Sidebar from "./component/pages/Dashboard/Sidebar";
// import Navbar from "./component/Navbar/Navbar";
// import SettingPageMain from "./component/pages/Dashboard/setting/pages/SettingPageMain";
// import Project from "./component/pages/Dashboard/Project/Project";
// import Assets from "./component/pages/Dashboard/AssetsModule/Assets";
// import Team from "./component/Organization/Team";
// import TeamManagement from "./component/Organization/TeamManagement";
// import CommonMaster from "../src/component/Common_master/CommonMaster.js";
// import CustomerList from "./component/pages/Dashboard/Customer/customer-list.jsx";
// import CustomerForm from "./component/pages/Dashboard/Customer/form.jsx";
// import AdminManager from "./component/AdminManager/AdminManager.js";
// import FloatingActionButton from "./component/common/FloatingActionButton";
// import ReportsPage from "../src/component/Report/Report.js";
// import ReportSettingsPage from "../src/component/Report/Reportsetting.js";
// import "./App.css";

// // --- Module-specific Imports ---
// import WorkOrder, {
//   WorkOrderFormPage,
// } from "./component/pages/Dashboard/WorkOrder/WorkOrder";
// import WorkOrderView from "./component/pages/Dashboard/WorkOrder/View";
// import Invoice, {
//   InvoiceFormPage,
// } from "./component/pages/Dashboard/Invoice/Invoice";
// import WorkType, {
//   WorkTypeFormPage,
// } from "../src/component/pages/Dashboard/WorkType/WorkType.js";
// import InvoicePrint from "./component/pages/Dashboard/Invoice/Print.js";

// // --- Create and export the RefreshContext ---
// export const RefreshContext = createContext();

// // --- REDIRECT URL ---
// const ZTOOL_LOGIN_REDIRECT_URL = `${process.env.REACT_APP_ZTOOL_URL}/login`;

// // --- JWT PARSING HELPER ---
// const parseJwt = (token) => {
//   try {
//     const base64Url = token.split(".")[1];
//     const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
//     const jsonPayload = decodeURIComponent(
//       atob(base64)
//         .split("")
//         .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
//         .join("")
//     );
//     return JSON.parse(jsonPayload);
//   } catch (error) {
//     console.error("Auth Error: Failed to parse JWT.", error);
//     return null;
//   }
// };

// // --- HELPER COMPONENTS ---
// const RedirectToLogin = ({ message }) => {
//   useEffect(() => {
//     window.location.replace(ZTOOL_LOGIN_REDIRECT_URL);
//   }, []);
//   return (
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "100vh",
//       }}
//     >
//       <h1>{message || "Redirecting to Login..."}</h1>
//     </div>
//   );
// };

// const ZTaskLoginPlaceholder = () => <RedirectToLogin />;

// // --- Main Layout Component ---
// const MainLayout = () => {
//   const [sidebarRefreshKey, setSidebarRefreshKey] = useState(0);
//   const [refreshKey, setRefreshKey] = useState(0);

//   const handleProfileUpdate = () => {
//     setSidebarRefreshKey((prevKey) => prevKey + 1);
//   };

//   const triggerRefresh = () => {
//     setRefreshKey((prevKey) => prevKey + 1);
//   };

//   return (
//     <RefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
//       <div className="app-layout">
//         <Sidebar refreshKey={sidebarRefreshKey} />
//         <div className="main-content-area">
//           <Navbar />
//           <div className="page-content-wrapper">
//             <Routes>
//               {/* --- Core Routes --- */}
//               <Route path="/" element={<DashboardPage />} />
//               <Route path="/dashboard" element={<DashboardPage />} />
//               <Route path="/project" element={<Project />} />
//               <Route path="/assets" element={<Assets />} />

//               {/* --- Customer Routes --- */}
//               <Route path="/customers" element={<CustomerList />} />
//               <Route path="/customers/new" element={<CustomerForm />} />
//               <Route path="/customers/:rowId/edit" element={<CustomerForm />} />

//               {/* --- Work Order Routes (View and Edit are included) --- */}
//               <Route path="/work-orders" element={<WorkOrder />} />
//               <Route path="/work-orders/new" element={<WorkOrderFormPage />} />
//               <Route
//                 path="/work-orders/:id/edit"
//                 element={<WorkOrderFormPage />}
//               />
//               <Route path="/work-orders/:id" element={<WorkOrderView />} />

//               {/* --- Invoice Routes --- */}
//               <Route path="/invoices" element={<Invoice />} />
//               <Route path="/invoices/new" element={<InvoiceFormPage />} />
//               <Route path="/invoices/:id/edit" element={<InvoiceFormPage />} />
//               <Route path="/invoices/:id" element={<InvoicePrint />} />

//               {/* --- Organization Routes --- */}
//               <Route path="/organization/team" element={<Team />} />
//               <Route
//                 path="/organization/team-management"
//                 element={<TeamManagement />}
//               />
//               <Route
//                 path="/organization/user-management"
//                 element={<AdminManager onProfileUpdate={handleProfileUpdate} />}
//               />
//               <Route
//                 path="/organization/common-master"
//                 element={<CommonMaster />}
//               />

//               {/* --- Work Type Routes --- */}
//               <Route path="/organization/work-types" element={<WorkType />} />
//               <Route
//                 path="/organization/work-types/new"
//                 element={<WorkTypeFormPage />}
//               />
//               <Route
//                 path="/organization/work-types/:rowId/edit"
//                 element={<WorkTypeFormPage />}
//               />

//               {/* --- Reports Routes --- */}
//               <Route path="/reports" element={<ReportsPage />} />
//               <Route
//                 path="/reports/settings"
//                 element={<ReportSettingsPage />}
//               />

//               {/* --- Settings & Auth Routes --- */}
//               <Route
//                 path="/settings/*"
//                 element={
//                   <SettingPageMain onProfileUpdate={handleProfileUpdate} />
//                 }
//               />
//               <Route path="/login" element={<ZTaskLoginPlaceholder />} />
//             </Routes>
//           </div>
//         </div>
//       </div>
//     </RefreshContext.Provider>
//   );
// };

// // --- AUTH HANDLER ---
// const AuthHandler = ({ children }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [authStatus, setAuthStatus] = useState("PENDING");

//   useEffect(() => {
//     const searchParams = new URLSearchParams(location.search);
//     const tokenFromUrl = searchParams.get("token");
//     const userDetailsEncodedFromUrl = searchParams.get("userDetails");

//     if (tokenFromUrl && userDetailsEncodedFromUrl) {
//       try {
//         const userDetails = JSON.parse(
//           decodeURIComponent(userDetailsEncodedFromUrl)
//         );
//         localStorage.setItem("zTaskAuthToken", tokenFromUrl);
//         localStorage.setItem("zTaskUserDetails", JSON.stringify(userDetails));
//         navigate(location.pathname, { replace: true, search: "" });
//         setAuthStatus("AUTHENTICATED");
//       } catch (e) {
//         console.error("Auth Error: Failed to parse user details from URL.", e);
//         localStorage.clear();
//         setAuthStatus("FAILED");
//       }
//       return;
//     }

//     const tokenFromLocalStorage = localStorage.getItem("zTaskAuthToken");
//     if (tokenFromLocalStorage) {
//       const decodedToken = parseJwt(tokenFromLocalStorage);
//       if (decodedToken && decodedToken.exp * 1000 < Date.now()) {
//         localStorage.clear();
//         setAuthStatus("EXPIRED");
//       } else {
//         setAuthStatus("AUTHENTICATED");
//       }
//     } else {
//       setAuthStatus("FAILED");
//     }
//   }, [location, navigate]);
//   //   alert("Auth Status: " + authStatus);

//   if (authStatus === "PENDING")
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//         }}
//       >
//         <h1>Verifying Session...</h1>
//       </div>
//     );
//   if (authStatus === "EXPIRED")
//     return (
//       <RedirectToLogin message="Your session has expired. Redirecting..." />
//     );
//   if (authStatus === "FAILED") return <RedirectToLogin />;

//   return children;
// };

// // --- Main App Component ---
// const App = () => {
//   return (
//     <BrowserRouter>
//       <AuthHandler>
//         <MainLayout />
//       </AuthHandler>
//     </BrowserRouter>
//   );
// };

// export default App;










import React, { useEffect, useState, createContext } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";

// --- Page & Layout Components ---
import DashboardPage from "./component/pages/Dashboard/Dashboard";
import Sidebar from "./component/pages/Dashboard/Sidebar";
import Navbar from "./component/Navbar/Navbar";
import SettingPageMain from "./component/pages/Dashboard/setting/pages/SettingPageMain";
import Project from "./component/pages/Dashboard/Project/Project";
import Assets from "./component/pages/Dashboard/AssetsModule/Assets";
import Team from "./component/Organization/Team";
import TeamManagement from "./component/Organization/TeamManagement";
import CommonMaster from "../src/component/Common_master/CommonMaster.js";
import CustomerList from "./component/pages/Dashboard/Customer/customer-list.jsx";
import CustomerForm from "./component/pages/Dashboard/Customer/form.jsx";
import AdminManager from "./component/AdminManager/AdminManager.js";
import FloatingActionButton from "./component/common/FloatingActionButton";
import ReportsPage from "../src/component/Report/Report.js";
import ReportSettingsPage from "../src/component/Report/Reportsetting.js";
import "./App.css";

// --- Module-specific Imports ---
import WorkOrder, {
  WorkOrderFormPage,
} from "./component/pages/Dashboard/WorkOrder/WorkOrder";
import WorkOrderView from "./component/pages/Dashboard/WorkOrder/View";
import Invoice, {
  InvoiceFormPage,
} from "./component/pages/Dashboard/Invoice/Invoice";
import WorkType, {
  WorkTypeFormPage,
} from "../src/component/pages/Dashboard/WorkType/WorkType.js";
import InvoicePrint from "./component/pages/Dashboard/Invoice/Print.js";

// --- Create and export the RefreshContext ---
export const RefreshContext = createContext();

// --- REDIRECT URL ---
const ZTOOL_LOGIN_REDIRECT_URL = `${process.env.REACT_APP_ZTOOL_URL}/login`;

// --- JWT PARSING HELPER ---
const parseJwt = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Auth Error: Failed to parse JWT.", error);
    return null;
  }
};

// --- HELPER COMPONENTS ---
const RedirectToLogin = ({ message }) => {
  useEffect(() => {
    window.location.replace(ZTOOL_LOGIN_REDIRECT_URL);
  }, []);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <h1>{message || "Redirecting to Login..."}</h1>
    </div>
  );
};

const ZTaskLoginPlaceholder = () => <RedirectToLogin />;

// --- Main Layout Component ---
const MainLayout = () => {
  const [sidebarRefreshKey, setSidebarRefreshKey] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleProfileUpdate = () => {
    setSidebarRefreshKey((prevKey) => prevKey + 1);
  };

  const triggerRefresh = () => {
    setRefreshKey((prevKey) => prevKey + 1);
  };

  return (
    <RefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
      <div className="app-layout">
        <Sidebar refreshKey={sidebarRefreshKey} />
        <div className="main-content-area">
          <Navbar />
          <div className="page-content-wrapper">
            <Routes>
              {/* --- Core Routes --- */}
              <Route path="/" element={<DashboardPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/project" element={<Project />} />
              <Route path="/assets" element={<Assets />} />

              {/* --- Customer Routes --- */}
              <Route path="/customers" element={<CustomerList />} />
              <Route path="/customers/new" element={<CustomerForm />} />
              <Route path="/customers/:rowId/edit" element={<CustomerForm />} />

              {/* --- Work Order Routes (View and Edit are included) --- */}
              <Route path="/work-orders" element={<WorkOrder />} />
              <Route path="/work-orders/new" element={<WorkOrderFormPage />} />
              <Route
                path="/work-orders/:id/edit"
                element={<WorkOrderFormPage />}
              />
              <Route path="/work-orders/:id" element={<WorkOrderView />} />

              {/* --- Invoice Routes --- */}
              <Route path="/invoices" element={<Invoice />} />
              <Route path="/invoices/new" element={<InvoiceFormPage />} />
              <Route path="/invoices/:id/edit" element={<InvoiceFormPage />} />
              <Route path="/invoices/:id" element={<InvoicePrint />} />
<Route path="/invoice/print/:id" element={<InvoicePrint />} />

              {/* --- Organization Routes --- */}
              <Route path="/organization/team" element={<Team />} />
              <Route
                path="/organization/team-management"
                element={<TeamManagement />}
              />
              <Route
                path="/organization/user-management"
                element={<AdminManager onProfileUpdate={handleProfileUpdate} />}
              />
              <Route
                path="/organization/common-master"
                element={<CommonMaster />}
              />

              {/* --- Work Type Routes --- */}
              <Route path="/organization/work-types" element={<WorkType />} />
              <Route
                path="/organization/work-types/new"
                element={<WorkTypeFormPage />}
              />
              <Route
                path="/organization/work-types/:rowId/edit"
                element={<WorkTypeFormPage />}
              />

              {/* --- Reports Routes --- */}
              <Route path="/reports" element={<ReportsPage />} />
              <Route
                path="/reports/settings"
                element={<ReportSettingsPage />}
              />

              {/* --- Settings & Auth Routes --- */}
              <Route
                path="/settings/*"
                element={
                  <SettingPageMain onProfileUpdate={handleProfileUpdate} />
                }
              />
              <Route path="/login" element={<ZTaskLoginPlaceholder />} />
            </Routes>
          </div>
        </div>
      </div>
    </RefreshContext.Provider>
  );
};

// --- AUTH HANDLER ---
const AuthHandler = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [authStatus, setAuthStatus] = useState("PENDING");

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tokenFromUrl = searchParams.get("token");
    const userDetailsEncodedFromUrl = searchParams.get("userDetails");

    if (tokenFromUrl && userDetailsEncodedFromUrl) {
      try {
        const userDetails = JSON.parse(
          decodeURIComponent(userDetailsEncodedFromUrl)
        );
        localStorage.setItem("zTaskAuthToken", tokenFromUrl);
        localStorage.setItem("zTaskUserDetails", JSON.stringify(userDetails));
        navigate(location.pathname, { replace: true, search: "" });
        setAuthStatus("AUTHENTICATED");
      } catch (e) {
        console.error("Auth Error: Failed to parse user details from URL.", e);
        localStorage.clear();
        setAuthStatus("FAILED");
      }
      return;
    }

    const tokenFromLocalStorage = localStorage.getItem("zTaskAuthToken");
    if (tokenFromLocalStorage) {
      const decodedToken = parseJwt(tokenFromLocalStorage);
      if (decodedToken && decodedToken.exp * 1000 < Date.now()) {
        localStorage.clear();
        setAuthStatus("EXPIRED");
      } else {
        setAuthStatus("AUTHENTICATED");
      }
    } else {
      setAuthStatus("FAILED");
    }
  }, [location, navigate]);
  //   alert("Auth Status: " + authStatus);

  if (authStatus === "PENDING")
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <h1>Verifying Session...</h1>
      </div>
    );
  if (authStatus === "EXPIRED")
    return (
      <RedirectToLogin message="Your session has expired. Redirecting..." />
    );
  if (authStatus === "FAILED") return <RedirectToLogin />;

  return children;
};

// --- Main App Component ---
const App = () => {
  return (
    <BrowserRouter>
      <AuthHandler>
        <MainLayout />
      </AuthHandler>
    </BrowserRouter>
  );
};

export default App;
